const types = {
    PICO_READY: 'PICO_READY',
    PICO_INIT: 'PICO_INIT',

    FRAME_INIT: 'FRAME/INIT',
    FRAME_LINK: 'FRAME/LINK',
    FRAME_CREATE: 'FRAME/CREATE_CHILD',
    FRAME_SHOW: 'FRAME/SHOW_CHILD',
    FRAME_HIDE: 'FRAME/HIDE_CHILD',
    FRAME_TOGGLE: 'FRAME/TOGGLE_CHILD',
    FRAME_DESTROY: 'FRAME/DESTROY_CHILD',
    FRAME_DELETE: 'FRAME/DELETE_CHILD',
    FRAME_SUBMIT: 'FRAME/SUBMIT',
    FRAME_PLAN_LINK: 'FRAME/PLAN_LINK',

    NETWORK_REQUEST: 'NETWORK/REQUEST',

    UPDATE_TOKENS: 'UPDATE_TOKENS',
    STORE_REFRESH_TOKEN: 'TOKEN/STORE/REFRESH',
    STORE_ACCESS_TOKEN: 'TOKEN/STORE/ACCESS',
    REMOVE_REFRESH_TOKEN: 'TOKEN/REMOVE/REFRESH',
    REMOVE_ACCESS_TOKEN: 'TOKEN/REMOVE/ACCESS',

    INVALIDATION_EVENT: 'LOADER/INVALIDATION_EVENT',
    SEND_EXTERNAL_LINK: 'SEND_EXTERNAL_LINK',
    SEND_APP_ERROR: 'SEND_APP_ERROR',
    PURCHASE_ARTICLE: 'PURCHASE_ARTICLE',
    CLOSE_PICO: 'CLOSE_PICO',
}

const creators = {
    picoReady: () => ({ type: types.PICO_READY }),
    picoInit: ({ origin }) => ({ type: types.PICO_INIT, origin }),
    initChild: ({ frame, payload }) => ({ type: types.FRAME_INIT, frame, payload }),
    createChild: ({ frame, payload }) => ({ type: types.FRAME_CREATE, frame, payload }),
    showChild: ({ frame, payload }) => ({ type: types.FRAME_SHOW, frame, payload }),
    hideChild: ({ frame, payload }) => ({ type: types.FRAME_HIDE, frame, payload }),
    toggleChild: ({ frame, payload }) => ({ type: types.FRAME_TOGGLE, frame, payload }),
    destroyChild: ({ frame, payload }) => ({ type: types.FRAME_DESTROY, frame, payload }),
    deleteChild: ({ frame, payload }) => ({ type: types.FRAME_DELETE, frame, payload }),
    // eslint-disable-next-line max-len
    updateTokens: ({ accessToken, refreshToken }) => ({ type: types.UPDATE_TOKENS, accessToken, refreshToken }),
    storeRefreshToken: ({ refreshToken }) => ({ type: types.STORE_REFRESH_TOKEN, refreshToken }),
    removeRefreshToken: () => ({ type: types.REMOVE_REFRESH_TOKEN }),
    storeAccessToken: ({ accessToken }) => ({ type: types.STORE_ACCESS_TOKEN, accessToken }),
    removeAccessToken: () => ({ type: types.REMOVE_ACCESS_TOKEN }),
    handleDirectLinks: ({ link, queryString }) => ({ type: types.FRAME_LINK, link, queryString }),
    handleSignupConfirmation: ({ email }) => ({ type: types.FRAME_SUBMIT, email }),
    handleDirectPlanLink: ({ planOptionId }) => ({ type: types.FRAME_PLAN_LINK, planOptionId }),
    sendExternalLink: ({ payload }) => ({ type: types.SEND_EXTERNAL_LINK, payload }),
    sendAppError: ({ payload }) => ({ type: types.SEND_APP_ERROR, payload }),
    purchaseArticle: () => ({ type: types.PURCHASE_ARTICLE }),
    closePico: () => ({ type: types.CLOSE_PICO }),
    invalidationEvent: ({ payload }) => ({ type: types.INVALIDATION_EVENT, ...payload }),
}

export {
    types,
    creators,
}
